/* =========================================================
   Forge — Visor de fotos con zoom.

   Se engancha a cualquier elemento con [data-fx]:
     data-fx-group    agrupa las fotos que navegan juntas
     data-fx-src      URL de la foto grande
     data-fx-caption  epigrafe opcional

   Zoom: rueda del mouse, doble clic o doble toque, y pellizco
   en mobile. Con la foto acercada se arrastra para moverla.
   ========================================================= */
(function () {
  'use strict';

  var MAX = 4, MIN = 1;
  var root = null, imgEl, capEl, countEl, prevBtn, nextBtn, zoomInBtn, zoomOutBtn;
  var group = [], index = 0, lastFocus = null;
  var scale = 1, tx = 0, ty = 0;
  var dragging = false, sx = 0, sy = 0, stx = 0, sty = 0;
  var pointers = new Map(), pinchStart = 0, pinchScale = 1;
  var lastTap = 0;

  function svg(d){
    return '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
      '<path d="' + d + '" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  }

  function build(){
    root = document.createElement('div');
    root.className = 'fx';
    root.setAttribute('aria-hidden','true');
    root.innerHTML =
      '<div class="fx__scrim" data-fx-close></div>' +
      '<div class="fx__stage" data-fx-stage><img class="fx__img" alt="" data-fx-img></div>' +
      '<div class="fx__bar">' +
        '<span class="fx__count" data-fx-count></span>' +
        '<button type="button" class="fx__btn" data-fx-zoomout aria-label="Alejar">' + svg('M5 12h14') + '</button>' +
        '<button type="button" class="fx__btn" data-fx-zoomin aria-label="Acercar">' + svg('M12 5v14M5 12h14') + '</button>' +
        '<button type="button" class="fx__btn" data-fx-close aria-label="Cerrar">' + svg('M6 6l12 12M18 6L6 18') + '</button>' +
      '</div>' +
      '<button type="button" class="fx__btn fx__nav fx__nav--prev" data-fx-prev aria-label="Foto anterior">' + svg('M15 6l-6 6 6 6') + '</button>' +
      '<button type="button" class="fx__btn fx__nav fx__nav--next" data-fx-next aria-label="Foto siguiente">' + svg('M9 6l6 6-6 6') + '</button>' +
      '<div class="fx__foot">' +
        '<p class="fx__cap" data-fx-cap></p>' +
        '<p class="fx__hint">Tocá dos veces o pellizcá para acercar</p>' +
      '</div>';
    document.body.appendChild(root);

    imgEl = root.querySelector('[data-fx-img]');
    capEl = root.querySelector('[data-fx-cap]');
    countEl = root.querySelector('[data-fx-count]');
    prevBtn = root.querySelector('[data-fx-prev]');
    nextBtn = root.querySelector('[data-fx-next]');
    zoomInBtn = root.querySelector('[data-fx-zoomin]');
    zoomOutBtn = root.querySelector('[data-fx-zoomout]');

    root.addEventListener('click', function(e){
      if (e.target.closest('[data-fx-close]')) return close();
      if (e.target.closest('[data-fx-prev]')) return go(-1);
      if (e.target.closest('[data-fx-next]')) return go(1);
      if (e.target.closest('[data-fx-zoomin]')) return zoom(scale + .75);
      if (e.target.closest('[data-fx-zoomout]')) return zoom(scale - .75);
    });

    var stage = root.querySelector('[data-fx-stage]');

    stage.addEventListener('wheel', function(e){
      e.preventDefault();
      zoom(scale + (e.deltaY < 0 ? .3 : -.3));
    }, { passive:false });

    stage.addEventListener('dblclick', function(e){
      e.preventDefault();
      zoom(scale > 1 ? 1 : 2.5);
    });

    stage.addEventListener('pointerdown', function(e){
      pointers.set(e.pointerId, e);
      if (pointers.size === 2) {
        pinchStart = spread();
        pinchScale = scale;
        return;
      }
      // Doble toque en mobile: no dispara dblclick nativo.
      var now = Date.now();
      if (e.pointerType === 'touch' && now - lastTap < 300) { zoom(scale > 1 ? 1 : 2.5); lastTap = 0; return; }
      lastTap = now;

      if (scale > 1) {
        dragging = true; root.classList.add('is-panning');
        sx = e.clientX; sy = e.clientY; stx = tx; sty = ty;
        stage.setPointerCapture(e.pointerId);
      }
    });

    stage.addEventListener('pointermove', function(e){
      if (pointers.has(e.pointerId)) pointers.set(e.pointerId, e);
      if (pointers.size === 2 && pinchStart) {
        zoom(pinchScale * (spread() / pinchStart), true);
        return;
      }
      if (!dragging) return;
      tx = stx + (e.clientX - sx);
      ty = sty + (e.clientY - sy);
      clamp(); apply();
    });

    function release(e){
      pointers.delete(e.pointerId);
      if (pointers.size < 2) pinchStart = 0;
      if (dragging) { dragging = false; root.classList.remove('is-panning'); }
    }
    stage.addEventListener('pointerup', release);
    stage.addEventListener('pointercancel', release);

    // Deslizar para cambiar de foto solo cuando no esta acercada.
    var swx = 0, swy = 0;
    stage.addEventListener('touchstart', function(e){
      if (scale !== 1 || e.touches.length !== 1) return;
      swx = e.touches[0].clientX; swy = e.touches[0].clientY;
    }, { passive:true });
    stage.addEventListener('touchend', function(e){
      if (scale !== 1 || !swx) return;
      var dx = e.changedTouches[0].clientX - swx;
      var dy = e.changedTouches[0].clientY - swy;
      if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy)) go(dx < 0 ? 1 : -1);
      swx = 0;
    }, { passive:true });

    document.addEventListener('keydown', function(e){
      if (!root.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') go(-1);
      else if (e.key === 'ArrowRight') go(1);
      else if (e.key === '+' || e.key === '=') zoom(scale + .5);
      else if (e.key === '-') zoom(scale - .5);
    });
  }

  function spread(){
    var p = Array.from(pointers.values());
    return Math.hypot(p[0].clientX - p[1].clientX, p[0].clientY - p[1].clientY);
  }

  function clamp(){
    if (!imgEl) return;
    // No dejamos que la foto se escape del todo de la pantalla.
    var r = imgEl.getBoundingClientRect();
    var maxX = Math.max(0, (r.width * scale - window.innerWidth) / 2 + 40);
    var maxY = Math.max(0, (r.height * scale - window.innerHeight) / 2 + 40);
    tx = Math.max(-maxX, Math.min(maxX, tx));
    ty = Math.max(-maxY, Math.min(maxY, ty));
  }

  function apply(){
    imgEl.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + scale + ')';
    root.classList.toggle('is-zoomed', scale > 1);
    if (zoomOutBtn) zoomOutBtn.disabled = scale <= MIN + .01;
    if (zoomInBtn) zoomInBtn.disabled = scale >= MAX - .01;
  }

  function zoom(next, live){
    scale = Math.max(MIN, Math.min(MAX, next));
    if (scale === 1) { tx = 0; ty = 0; }
    else clamp();
    if (live) root.classList.add('is-panning');
    apply();
    if (live) requestAnimationFrame(function(){ root.classList.remove('is-panning'); });
  }

  function show(i){
    index = (i + group.length) % group.length;
    var it = group[index];
    scale = 1; tx = 0; ty = 0;
    imgEl.src = it.src;
    imgEl.alt = it.alt || '';
    capEl.textContent = it.caption || '';
    capEl.style.display = it.caption ? '' : 'none';
    countEl.textContent = group.length > 1 ? (index + 1) + ' / ' + group.length : '';
    var solo = group.length < 2;
    prevBtn.style.display = solo ? 'none' : '';
    nextBtn.style.display = solo ? 'none' : '';
    apply();
  }

  function go(step){ if (group.length > 1) show(index + step); }

  function open(trigger){
    if (!root) build();
    var name = trigger.getAttribute('data-fx-group') || '';
    var nodes = name
      ? document.querySelectorAll('[data-fx][data-fx-group="' + name + '"]')
      : [trigger];
    group = Array.prototype.map.call(nodes, function(n){
      return {
        src: n.getAttribute('data-fx-src'),
        alt: n.getAttribute('data-fx-alt') || (n.querySelector('img') ? n.querySelector('img').alt : ''),
        caption: n.getAttribute('data-fx-caption') || ''
      };
    });
    var start = Array.prototype.indexOf.call(nodes, trigger);
    lastFocus = trigger;
    show(start < 0 ? 0 : start);
    root.classList.add('is-open');
    root.setAttribute('aria-hidden','false');
    document.body.style.overflow = 'hidden';
    root.querySelector('[data-fx-close]:not(.fx__scrim)').focus();
  }

  function close(){
    if (!root) return;
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden','true');
    document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  // Delegado: sirve para lo que ya esta y para lo que se agregue despues.
  document.addEventListener('click', function(e){
    var t = e.target.closest('[data-fx]');
    if (!t || !t.getAttribute('data-fx-src')) return;
    e.preventDefault();
    open(t);
  });
})();
